import { Gender } from "@dcc/types/gender";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import {
  MONTHLY_PERCENTAGE_MALE,
  MONTHLY_PERCENTAGE_FEMALE,
  TWICEMONTHLY_PERCENTAGE_MALE,
  TWICEMONTHLY_PERCENTAGE_FEMALE
} from "@dcc/constants/monthlyPercentages";
export const getMonthlyPercentageOfPopulation = (
  gender: Gender,
  drinkFrequency: DrinkFrequency
) => {
  if (drinkFrequency === DrinkFrequency.Monthly) {
    return gender === Gender.Male
      ? MONTHLY_PERCENTAGE_MALE
      : MONTHLY_PERCENTAGE_FEMALE;
  } else {
    return gender === Gender.Male
      ? TWICEMONTHLY_PERCENTAGE_MALE
      : TWICEMONTHLY_PERCENTAGE_FEMALE;
  }
};
